import { useHandler, QueryParamsObserver } from 'labguard-cdk'
import { calculateEnclosingPeriod } from 'src/services/period'
import { usePeriodState } from 'src/hooks'

/**
 * Hook providing handlers to zoom on a note, an alarm, a particular interval, or reset the zoom
 */
export default function useZoomHandlers() {
  const [period] = usePeriodState()

  const computeNewPeriod = useHandler(item => {
    const { from, to } = calculateEnclosingPeriod(item, period)
    return {
      from: from ? from.toISOString() : undefined,
      to: to ? to.toISOString() : undefined,
    }
  })

  const zoomOnNote = useHandler(note =>
    QueryParamsObserver.set(state => ({
      ...state,
      zoomFrom: undefined,
      zoomTo: undefined,
      alarmId: undefined,
      noteId: note.id,
      ...computeNewPeriod(note),
    }))
  )

  const zoomOnAlarm = useHandler(alarm =>
    QueryParamsObserver.set(state => ({
      ...state,
      zoomFrom: undefined,
      zoomTo: undefined,
      alarmId: alarm.id,
      noteId: undefined,
      ...computeNewPeriod(alarm),
    }))
  )

  const zoomOnInterval = useHandler(([zoomFrom, zoomTo] = []) =>
    QueryParamsObserver.set(state => ({
      ...state,
      zoomFrom: zoomFrom && new Date(zoomFrom).toISOString(),
      zoomTo: zoomTo && new Date(zoomTo).toISOString(),
      alarmId: undefined,
      noteId: undefined,
    }))
  )

  const clearZoom = useHandler(() => zoomOnInterval())

  return { zoomOnAlarm, zoomOnNote, zoomOnInterval, clearZoom }
}
